import { Alert } from 'antd';

type Props = {
  text: string;
};

export default function ErrorNotification({ text }: Props) {
  return <Alert message={text} type="error" className="w-full !mb-2" />;
}
